import { createListenerMiddleware } from '@reduxjs/toolkit';
import toastTrigger from '@ui/toast/toast-trigger';
import { EToastTypes } from '@ui/toast/toast.types';

import { loadProject } from '..';
import { RootState } from '@/store/main';
import { SerializedError } from '@/store/utils/serialize-error';
import { getUser } from '@/store/slices/user/selectors';
import { EPermissions } from '@/types/permissions.types';
import { getLeavePlatformLink } from '@/utils/navigation/get-leave-platform-link';
import { getBaseAdminURL } from '@/utils/urls';

const loadProjectErrorMiddleware = createListenerMiddleware();

loadProjectErrorMiddleware.startListening({
  actionCreator: loadProject.rejected,
  effect: async (action, listenerApi) => {
    const toastId = 'project-load-error';

    const payload = action.payload as SerializedError | string | undefined;
    const status = typeof payload === 'object' ? payload?.status : undefined;

    if (status === 403) {
      const state = listenerApi.getState() as RootState;
      const user = getUser(state);
      const channelRoles = (user && user.active_channel != null && user.channels?.[user.active_channel]) || [];
      const isAnalyticsOnly = channelRoles.length > 0 && channelRoles.every((role) => role === EPermissions.Analytics);

      toastTrigger('You do not have permission to access this project', {
        type: EToastTypes.error,
        autoClose: 10000,
        toastId,
        description: `Redirecting to ${isAnalyticsOnly ? 'Stats page' : 'admin console'}`,
      });
      setTimeout(() => {
        window.location.href = isAnalyticsOnly ? getLeavePlatformLink('/stats') : getBaseAdminURL() + '/admin';
      }, 4500);
      return;
    }

    toastTrigger('Error loading project', {
      type: EToastTypes.error,
      autoClose: 5000,
      toastId,
      description: 'Please try again later',
    });
  },
});

export default loadProjectErrorMiddleware;
